import { NotificationOpenedResult } from "@app/core/notifications/domain/notification-open-result";
import { Observable } from "rxjs";

export abstract class PushNotificationsService {
  abstract init(appId: string): void;

  abstract get onNotificationOpen$(): Observable<NotificationOpenedResult>;

  abstract get onSubscriptionChange$(): Observable<string | undefined>;

  abstract get onNotificationReceived$(): Observable<void>;

  abstract requestPermissions(): Observable<boolean>;

  abstract enableNotifications(): void;
}
